var reservationOrderSubmit = {
  submitButton: $('#reservation_order_submit'),
  spzInput: $('#reservation_order_spz'),
  phoneInput: $('#reservation_order_phoneNumber'),
  fullNameInput: $('#reservation_order_fullName'),
  timeInputs: $('input[name="reservation_order[reservationTime]"]'),
  phoneNumberError: $('#phone-number-error'),
  timeError: $('#reservation-time-error'),
  phoneError: false,
  totalPriceBlock: $('#total-price'),
  buyNewTyres: $('#reservation_order_buyNewTyres'),
  storeTyres: $('#reservation_order_storeTyres'),
  pickupService: $('#reservation_order_pickupService'),
  reservationServiceChoices: $('.reservation-service-choices'),
  totalPriceInput: $('#reservation_order_totalPrice'),

  init: function () {
    this.form = this.submitButton.closest('form');
    toastr.options.positionClass = 'toast-bottom-center';
    this.totalPriceInput.val(this.totalPriceBlock.data('price'));

    var app = this;
    this.submitButton.on('click', function (event) {
      if (app.form[0].checkValidity()) {
        event.preventDefault();
        if (!app.phoneError && app.checkTimeInputs() && app.checkPhoneInput()) {
          $('.error-messages').remove();
          app.submitForm(app.form.serialize());
        }
      }
    });

    this.reservationServiceChoices.each(function () {
      var that = $(this);
      that.on('change', function () {
        var block = $('#' + this.id + '-block');
        var price = $('#' + this.id + '-price');
        var totalPrice = app.totalPriceBlock.data('price');
        if ($(this).is(':checked')) {
          block.show();
          price.show();
          totalPrice += price.data('price');
        } else {
          block.hide();
          price.hide();
          totalPrice -= price.data('price');
        }
        app.changeTotalPrice(totalPrice);
      });
    });
    this.buyNewTyres.on('change', function () {
      var block = $('#buy-new-tyres-block');
      var price = $('#buy-new-tyres-price');
      if ($(this).is(':checked')) {
        block.show();
        price.show();
      } else {
        block.hide();
        price.hide();
      }
    });
    this.storeTyres.on('change', function () {
      var storeTyresBlock = $('#store-tyres-block');
      var storeTyresPrice = $('#store-tyres-price');
      var totalPrice = app.totalPriceBlock.data('price');
      if ($(this).is(':checked')) {
        storeTyresBlock.show();
        storeTyresPrice.show();
        totalPrice += storeTyresPrice.data('price');
      } else {
        storeTyresBlock.hide();
        storeTyresPrice.hide();
        totalPrice -= storeTyresPrice.data('price');
      }
      app.changeTotalPrice(totalPrice);
    });
    this.pickupService.on('change', function () {
      var pickupServiceBlock = $('#pickup-service-block');
      var pickupServicePrice = $('#pickup-service-price');
      var totalPrice = app.totalPriceBlock.data('price');
      if ($(this).is(':checked')) {
        pickupServiceBlock.show();
        pickupServicePrice.show();
        totalPrice += pickupServicePrice.data('price');
      } else {
        pickupServiceBlock.hide();
        pickupServicePrice.hide();
        totalPrice -= pickupServicePrice.data('price');
      }
      app.changeTotalPrice(totalPrice);
    });
    this.timeInputs.on('click', function () {
      app.timeError.addClass('is-hidden');
    });
    this.spzInput.keyup(function () {
      $(this).val($(this).val().replace('-', ''));
    });
    this.fullNameInput.keyup(function () {
      $(this).val($(this).val().replace(/\d+/, ''));
    });
    this.phoneInput.keyup(function () {
      $(this).val($(this).val().replace(/\D/g, '').replace('420', ''));
      if ($(this).val().length > 9) {
        app.phoneNumberError.removeClass('is-hidden');
        app.phoneError = true;
      } else {
        app.phoneNumberError.addClass('is-hidden');
        app.phoneError = false;
      }
    });
  },
  submitForm: function (serializedForm) {
    var app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.ok) {
          // app.showMessage(response.message, 'success');
          // renderTimeBlocks(response);
          window.location.replace(response.redirectUrl);
        } else {
          renderTimeBlocks(response);
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function (jqXHR, status) {
        app.enableButton();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
  checkTimeInputs: function () {
    var checked = $('input[name="reservation_order[reservationTime]"]:checked');

    if (!checked.length) {
      this.timeError.removeClass('is-hidden');
      return false;
    } else {
      this.timeError.addClass('is-hidden');
      return true;
    }
  },
  checkPhoneInput: function () {
    if (this.phoneInput.val().length !== 9) {
      this.phoneNumberError.removeClass('is-hidden');
      this.phoneError = true;

      return false;
    } else {
      this.phoneNumberError.addClass('is-hidden');
      this.phoneError = false;

      return true;
    }
  },
  changeTotalPrice: function (newTotalPrice) {
    this.totalPriceBlock.data('price', newTotalPrice);
    this.totalPriceBlock.text(newTotalPrice);
    this.totalPriceInput.val(newTotalPrice);
  },
};

$(function () {
  reservationOrderSubmit.init();
});

$('#reservation_order_reservationDate')
  .datetimepicker({
    format: 'DD.MM.YYYY',
    locale: 'cs',
    minDate: moment($('#available-date').val(), 'DD.MM.YYYY')
      .millisecond(0)
      .second(0)
      .minute(0)
      .hour(0),
  })
  .on('dp.change', function (e) {
    var formatedValue = e.date.format(e.date._f);
    $.ajax({
      url: $('#reservation-change-order-api-url').val(),
      method: 'POST',
      data: { date: formatedValue },
      beforeSend: function () {
        var inputs = $('input[name="reservation_order[reservationTime]"]');
        inputs.each(function () {
          $(this).attr('disabled', true).attr('checked', false);
        });
      },
      success: function (response) {
        if (response.ok) {
          renderTimeBlocks(response);
        } else {
          console.log(response);
        }
      },
      error: function (response) {
        console.log(response);
      },
      complete: function (jqXHR, status) {
        // app.enableButton();
        // app.form[0].reset();
      },
    });
  });

function renderTimeBlocks(response) {
  console.log(response.timeBlocks);
  var inputs = $('input[name="reservation_order[reservationTime]"]');

  inputs.each(function () {
    var that = $(this);
    for (var i = 0; i < response.timeBlocks.length; i++) {
      if (that.val() === response.timeBlocks[i]['time']) {
        if (response.timeBlocks[i]['status'] === 'free') {
          that.attr('disabled', false);
        } else {
          that.attr('disabled', true);
        }
      }
    }
  });
}
